
import { defineComponent, PropType } from 'vue'
import { Clasificacion } from '@/api'

export default defineComponent({
  name: 'ClasificacionSelect',
  props: {
    modelValue: { type: Object as PropType<Clasificacion>, required: false, },
    clasificaciones: { type: Array as PropType<Array<Clasificacion>>, required: true, },
  },
  data () {
    return {
      selectedValue: undefined as Clasificacion | undefined,
      collapsed: [] as boolean[],
    }
  },
  emits: {
    'update:modelValue': (payload: Clasificacion | undefined) => {
      // perform runtime validation
      return payload !== undefined
    },
  },
  methods: {
    selectClasificacion (clasificacion: Clasificacion | undefined) {
      if (clasificacion === this.selectedValue) {
        this.selectedValue = undefined
        this.$emit('update:modelValue', undefined)
      } else {
        this.selectedValue = clasificacion
        this.$emit('update:modelValue', clasificacion)
      }
    },
    selectedChild (clasificacion: Clasificacion | undefined) {
      this.selectClasificacion(clasificacion)
    },
    toggleCollapsed (id: number) {
      this.collapsed[id] = !this.collapsed[id]
    },
  },
  watch: {
    modelValue (newValue: Clasificacion | undefined, _oldValue: Clasificacion | undefined) {
      this.selectedValue = newValue
    },
  },
  beforeMount () {
    this.collapsed = Array(this.clasificaciones.length).fill(true)
  },
})
